/**
 * Generated from hh_ch2_72dpi_p01.fla
 */
export function hh_ch2_72dpi_p01(this: Ihh_ch2_72dpi_p01) {
	const bg = this.bg;
	hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_bg.call(this.bg);
	bg.x = 250.25;
	bg.y = 384;
	bg.width = 500.50;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const cafe = this.cafe;
	hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_cafe.call(this.cafe);
	cafe.x = 892.75;
	cafe.y = 384;
	cafe.width = 1542.50;
	cafe.height = 768.00;
	cafe.alpha = 1.00;
	if (cafe.onLayout) cafe.onLayout();
	const holly = this.holly;
	hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_holly.call(this.holly);
	holly.x = 552.75;
	holly.y = 713;
	holly.width = 154.50;
	holly.height = 379.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const lights = this.lights;
	hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_lights.call(this.lights);
	lights.x = 832;
	lights.y = 384;
	lights.width = 1664.00;
	lights.height = 768.00;
	lights.alpha = 1.00;
	if (lights.onLayout) lights.onLayout();
	const frameLeft = this.frameLeft;
	hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeL.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 687.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const frameRight = this.frameRight;
	hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeR.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 1292.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const lines = this.lines;
	hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeBGlines.call(this.lines);
	lines.x = 832;
	lines.y = 384;
	lines.width = 1664.00;
	lines.height = 768.00;
	lines.alpha = 1.00;
	if (lines.onLayout) lines.onLayout();
	return this;
}
function hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_bg(this: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p01_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_cafe(this: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_cafe) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p01_cafe", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_holly(this: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p01_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_lights(this: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_lights) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p01_lights", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeL(this: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeR(this: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeBGlines(this: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeBGlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("BGlines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
interface Ihh_ch2_72dpi_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ihh_ch2_72dpi_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ihh_ch2_72dpi_p01Sprite extends Ihh_ch2_72dpi_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ihh_ch2_72dpi_p01Text extends Ihh_ch2_72dpi_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ihh_ch2_72dpi_p01Polygon extends Array<number> {
}
interface Ihh_ch2_72dpi_p01 {
	readonly bg: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_bg;
	readonly cafe: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_cafe;
	readonly holly: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_holly;
	readonly lights: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_lights;
	readonly frameLeft: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeL;
	readonly frameRight: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeR;
	readonly lines: Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeBGlines;
}
interface Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_bg extends Ihh_ch2_72dpi_p01Sprite {
}
interface Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_cafe extends Ihh_ch2_72dpi_p01Sprite {
}
interface Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_holly extends Ihh_ch2_72dpi_p01Sprite {
}
interface Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_lights extends Ihh_ch2_72dpi_p01Sprite {
}
interface Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeL extends Ihh_ch2_72dpi_p01Sprite {
}
interface Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeR extends Ihh_ch2_72dpi_p01Sprite {
}
interface Ihh_ch2_72dpi_p01_hh_ch2_72dpi_p01psdAssetP1chp2_p01_wcframeBGlines extends Ihh_ch2_72dpi_p01Sprite {
}
